module.exports = __webpack_public_path__ + "img/owl.be5030ca.webp";